import { api } from '../core';
import { MEDICAL_MATCH_LIVE_PROCESSING_TAG, MEDICAL_MATCH_LIVE_STATUS_TAG } from '../constants';

// The endpoint answers with an empty object — a 200 only means the worker job
// was enqueued, not that the questions have been answered.
export type SendLiveQuestionsResponse = Record<string, never>;

export interface SendLiveQuestionsRequest {
  caseId: string;
  questions: string[];
}

const sendLiveQuestionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendLiveQuestions: builder.mutation<SendLiveQuestionsResponse, SendLiveQuestionsRequest>({
      query: ({ caseId, questions }: SendLiveQuestionsRequest) => ({
        url: 'medical-match-custom/send-live-questions',
        method: 'POST',
        body: { caseId, questions },
      }),
      // The endpoint inserts the questions as PROCESSING rows before returning,
      // so invalidating the live-processing queue gives the panel the row it
      // then polls on. Retries are off because a repeated POST burns another
      // slot of the user's daily question limit.
      invalidatesTags: (_result, _err, { caseId }) => [
        { type: MEDICAL_MATCH_LIVE_PROCESSING_TAG, id: caseId },
        { type: MEDICAL_MATCH_LIVE_STATUS_TAG, id: caseId },
      ],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useSendLiveQuestionsMutation } = sendLiveQuestionsApi;
